export enum Colors {
  Red = "accent",
  LightBlue = "lightBlue",
  Yellow = "yellow",
  Green = "green",
}
